import axios from '@/utils/request'
//业务员职级列表
export const getBrandSaleRank = (params) => {
  return axios.request({
    url: 'v2/brandSaleRank',
    method: 'get',
    params
  })
};
// 添加职级
export const createBrandSaleRank = (data) => {
  return axios.request({
    url: 'v2/brandSaleRank',
    method: 'POST',
    data
  })
};
// 修改职级
export const updateBrandSaleRank = (id, data) => {
  return axios.request({
    url: 'v2/brandSaleRank/' + id,
    method: 'PATCH',
    data
  })
};
// 删除职级
export const delBrandSaleRank = (id, data) => {
  return axios.request({
    url: 'v2/brandSaleRank/' + id,
    method: 'DELETE',
    data
  })
};

// 业务员列表
export const getBrandSale = (params) => {
  return axios.request({
    url: 'v2/brandSale',
    method: 'get',
    params
  })
};
// 创建业务员
export const createBrandSale = (data) => {
  return axios.request({
    url: 'v2/brandSale',
    method: 'post',
    data
  })
};
// 业务员详情
export const getBrandSaleDetail = (id, params) => {
  return axios.request({
    url: 'v2/brandSale/' + id,
    method: 'get',
    params
  })
};
// 修改业务员
export const updateBrandSale = (id, data) => {
  return axios.request({
    url: 'v2/brandSale/' + id,
    method: 'PATCH',
    data
  })
};
// 禁用业务员
export const uBrandSaleEnable = (id, data) => {
  return axios.request({
    url: 'v2/brandSale/enable/' + id,
    method: 'POST',
    data
  })
};
// 删除业务员
export const uBrandSaleDel = (id, data) => {
  return axios.request({
    url: 'v2/brandSale/' + id,
    method: 'DELETE',
    data
  })
};
// 业务员管辖的经销商
export const getBrandSaleDealer = (id, params) => {
  return axios.request({
    url: 'v2/brandSale/dealers/' + id,
    method: 'get',
    params
  })
};
// 业务员管辖的经销商
// export const getBrandSaleDealer = (id, params) => {
//   return axios.request({
//     url: 'v2/brandSale/dealers/' + id,
//     method: 'get',
//     params
//   })
// };


// 业务员菜单  
export const getBrandSaleMenu = (params) => {
  return axios.request({
    url: 'v2/brandSaleMenu',
    method: 'get',
    params
  })
};
// 业务员常用菜单 
export const getBrandSaleOftenUseMenu = (params) => {
  return axios.request({
    url: 'v2/brandSaleOftenUseMenu',
    method: 'get',
    params
  })
};
// 设置业务员常用菜单
export const setBrandSaleOftenUseMenu = (data) => {
  return axios.request({
    url: 'v2/brandSaleOftenUseMenu',
    method: 'post',
    data
  })
};

// 获取业务员常用菜单 
export const getBrandSaleLoginTem = (params) => {
  return axios.request({
    url: 'v2/brandSaleLoginTem',
    method: 'get',
    params
  })
};
// 设置业务员登录样式
export const setBrandSaleLoginTem = (data) => {
  return axios.request({
    url: 'v2/brandSaleLoginTem',
    method: 'post',
    data
  })
};
